import axios from "@/app/plugins/Axios";

function listar(paginacao) {
  return axios
    .get("categorias-contas", { params: paginacao })
    .then((response) => response.data);
}

function listarCategorias() {
  return axios
    .get("categorias-contas/lista")
    .then((response) => response.data);
}

function buscar(busca) {
  return axios
    .get(`categorias-contas/buscar?busca=${busca}`)
    .then((response) => response.data);
}

function buscarPorCodigo(codigo) {
  return axios
    .get(`categorias-contas/buscarCodigo?codigo=${codigo}`)
    .then((response) => response.data);
}

function abrir(id) {
  return axios.get(`/categorias-contas/${id}`).then((response) => response.data);
}

function salvar(categoria) {
  return axios.post("/categorias-contas", categoria).then((response) => response.data);
}

function atualizar(categoria) {
  return axios.put(`/categorias-contas/${categoria.id}`, categoria).then((response) => response.data);
}

function excluir(id) {
  return axios.delete(`/categorias-contas/${id}`).then((response) => response.data);
}

export default {
  listar,
  listarCategorias,
  buscar,
  buscarPorCodigo,
  abrir,
  salvar,
  atualizar,
  excluir,
};
